


























import { Component, Inject, Mixins } from "vue-property-decorator";

// Mixins
import Context from "@/mixins/context";

// Enums/Data
import { FraudStatus } from "@/data/enums";

// Types
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import { IFraudMindProviderMethods } from "@/models/providers/fraud";

@Component({
  components: {
    "fraud-provider": () =>
      import("@/components/app/global/fraud/fraudProvider.vue")
  }
})
export default class CProdPausedProvisionMsg extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  public get cProdData() {
    return this.$cProdData();
  }

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  @Inject({ from: "fraudMindProviderMethods" })
  public $fraudMethods!: IFraudMindProviderMethods;

  // Computed

  public get isVisible() {
    if (!this.isAdmin) return false;
    if (!this.cProdData.isAwaitingActivation) return false;
    if (!this.cProdData.isProvisionable) return false;
    return this.clientIsNotApproved || this.contractIsNotApproved;
  }

  public get clientIsNotApproved() {
    return (
      this.cProdData.contract.client.fraud_status !== FraudStatus.NOT_FRAUD
    );
  }

  public get contractIsNotApproved() {
    return this.cProdData.contract.fraud_status !== FraudStatus.NOT_FRAUD;
  }
}
